module.exports = __webpack_public_path__ + "static/media/Alias History Visualizer.ec322387.png";